import { format } from "date-fns";

import { TableColumn } from "@/components/Table/Table";

import { SortParams } from "@/types/types";

import { ListPerson } from "../../schema/list";
import { getOrderStatus } from "../column-utils";

/**
 * "Enriched at" column (PREC-3536 Phase 5, decision #4): backed by
 * `prospect.lastEnrichedAt` and directly orderable, so freshly (re-)enriched leads can be
 * surfaced. The "Last added/enriched" sort (PREC-3544) additionally targets
 * `list_person.updatedAt`, which every (re-)enrichment bumps.
 */
export const renderEnrichedAtColumn = (
	ts: (key: string) => string,
	sortingInbox: SortParams
): TableColumn => {
	const orderTitle = "prospect.lastEnrichedAt";

	return {
		title: ts("enrichedAt"),
		width: "fit-content",
		orderTitle,
		orderStatus: getOrderStatus(sortingInbox, orderTitle),
		uid: "enrichedAt",
		hideable: true,
		moveable: true,
		show: true,
		render: (row: ListPerson) => (
			<div className="flex items-center" data-test="enriched-at-cell">
				{row.prospect?.lastEnrichedAt
					? format(new Date(row.prospect.lastEnrichedAt), "yyyy-MM-dd HH:mm")
					: "—"}
			</div>
		),
	};
};
